module.exports = __webpack_public_path__ + "static/Heartlock-b168f72e52e23ba92cbd235a3028d17a.svg";